export default "__VITE_ASSET__B5JWK$gh__"